import React from "react";

const Loader = () => {
  return (
    <div className="container">
      <div className="loader">Loading...</div>
    </div>
  );
};

export default Loader;
